import React, { PropTypes } from "react";
import { ModalBackground, ModalDialog } from "react-modal-dialog";
import Form from "../../layout/feedback/Form";
import colors from "../../../styles/colors";
import styled from "styled-components";

const Button = styled.div`
  background-image: url('data:image/svg+xml;utf8,<svg aria-hidden="true" data-prefix="fas" data-icon="comment-alt" class="svg-inline--fa fa-comment-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#333333" d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"></path></svg>');
  background-position: center;
  background-size: 100%;
  bottom: 12px;
  height: 30px;
  position: absolute;
  right: 15px;
  transition: background-image 0.3s ease;
  width: 30px;

  @media screen and (max-width: 670px) {
    height: 25px;
    width: 25px;
  }

  &:hover {
    background-image: url('data:image/svg+xml;utf8,<svg aria-hidden="true" data-prefix="fas" data-icon="comment-alt" class="svg-inline--fa fa-comment-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#8cd0c5" d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"></path></svg>');
    cursor: pointer;
  }
`;

const Dialog = styled(ModalDialog)`
  > a {
    display: none;
  }
`;

export default class Feedback extends React.Component {
  state = {
    isShowingModal: false
  };

  handleClick = () => this.setState({ isShowingModal: true });
  handleClose = () => this.setState({ isShowingModal: false });

  render() {
    return (
      <Button onClick={this.handleClick}>
        {this.state.isShowingModal && (
          <ModalBackground
            onClose={this.handleClose}
            backgroundColor="#333333"
            zIndex="15"
          >
            <Dialog
              onClose={this.handleClose}
              style={{
                border: `1px solid ${colors.border}`,
                borderRadius: "0px",
                boxShadow: "none"
              }}
            >
              <Form />
            </Dialog>
          </ModalBackground>
        )}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/feedback/Feedback.js